import React, { useCallback, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '~/shared/ErrorBoundary';
import routes, { useAppNavigate } from '~/pages';
import { ApiEnvironmentsList, ApiEnvironmentsNames, ClientType, api, authHeaders, clients, getAllLocations, getMember, isDemoPhone, observer, useAppSettings, useImageLinks, useQaAgent, useSpringBigStore } from '@springbig/shared';
import Layout from './shared/Layout';
import NotFound from './pages/404/NotFound';
import { useBoolean } from 'usehooks-ts';
import { useColorMode } from 'native-base';

const AppRoutes = ({ updateMerchant }: { updateMerchant: (client: ClientType) => void }) => {

    const {
        setValue: setIsAuth,
        value: isAuth
    } = useBoolean(false);

    const { colorMode } = useColorMode();
    const { merchantOrg, forceColorMode } = useAppSettings();
    const {
        setMember,
        setMemberId,
        setMerchantId,
        walletId,
        phoneNumber,
        mobileSubscriberId,
        setDemoMode,
        setColorMode,
        setMerchant,
        setApiEnv,
        apiEnv,
        logout,
        setQAMerchant,
        qaMerchant
    } = useSpringBigStore();

    const { isQaAgent } = useQaAgent();
    const merchant = new URLSearchParams(window.location.search).get('merchant');

    // will trigger a redirection to a specific plan if present
    const plan = new URLSearchParams(window.location.search).get('plan');
    if (plan) {
        localStorage.setItem('plan_id', plan);
    }

    // will trigger a redirection to the subscriptions page if present
    const link = new URLSearchParams(window.location.search).get('link');
    if (link) {
        localStorage.setItem('link_id', link);
    }

    useEffect(() => {

        if (isQaAgent && qaMerchant) {
            logout();
            updateMerchant(qaMerchant as any);
        }
    }, [isQaAgent, updateMerchant, qaMerchant]);

    useEffect(() => {
        const env = new URLSearchParams(window.location.search).get('env');
        updateTheEnv(env as ApiEnvironmentsNames);

        (async () => {
            merchant && merchant !== qaMerchant && await setQAMerchant(merchant);
        })();
    }, []);

    useImageLinks();

    useEffect(() => {
        updateTheEnv(apiEnv as ApiEnvironmentsNames);
    }, [apiEnv]);



    const updateTheEnv = (env: ApiEnvironmentsNames) => {
        if (env && ApiEnvironmentsList.includes(env)) {
            (async () => {
                await setApiEnv(env);
                observer.emit('switch-env', { env });
            })();
        }
    };

    const handleMember = useCallback(async () => {

        if (!walletId) {
            return;
        }

        const _member = await getMember({ walletId });

        if (_member) {

            setMember(_member);
            setMemberId(_member.id);
            api.setStore({
                member: _member,
                memberId: _member.id,
            });
        }

        setIsAuth(true);

    }, [walletId, setMember, setMemberId, setIsAuth]);

    const getMerchant = useCallback(async (wId: string, phone: string) => {

        updateTheEnv(apiEnv as ApiEnvironmentsNames);
        if (phoneNumber && mobileSubscriberId) {

            const { hmac, time } = authHeaders(phoneNumber, mobileSubscriberId);
            const opts = {
                headers: {
                    'hmac-timestamp': `${time}`,
                    'hmac-signature': hmac
                }
            };
            const merchants = merchantOrg !== 'NOTCONFIGURED' && await getAllLocations({
                phoneNumber: phone,
                merchantOrganization: merchantOrg,
            }, opts);

            const merchant = merchants && merchants.length > 0 && merchants.find((m) => m.member_key === wId);

            if (merchant) {
                setMerchant(merchant.merchant);
                setMerchantId(merchant.merchant.id);
                api.setStore({ merchantId: merchant.merchant.id });
            }
        }

    }, [merchantOrg, setMerchant, setMerchantId, phoneNumber, mobileSubscriberId, apiEnv]);

    useEffect(() => {

        if (phoneNumber && isDemoPhone(phoneNumber)) {
            setDemoMode(true);
            api.toggleDemo(true);
        }

        if (phoneNumber && !isDemoPhone(phoneNumber)) {
            setDemoMode(false);
            api.toggleDemo(false);
        }

    }, [phoneNumber, setDemoMode]);

    useEffect(() => {

        if (forceColorMode && forceColorMode !== colorMode) {

            setColorMode(forceColorMode);
            return;
        }

        if (forceColorMode) {

            return;
        }

        if (!colorMode) {
            setColorMode('light');
        }

    }, [forceColorMode, colorMode, setColorMode]);

    useEffect(() => {

        if (walletId && phoneNumber) {

            handleMember();
            getMerchant(walletId, phoneNumber);
            return;
        }

    }, [walletId, phoneNumber, getMerchant, handleMember, mobileSubscriberId, apiEnv]);

    const displayComponent = routes.map((route, index) => {

        const { path } = route;

        return (
            <Route
                key={index}
                path={path}
                element={
                    <ErrorBoundary name={path} isQaAgent={isQaAgent}>
                        {route.auth ? <LayoutWarpper>
                            <route.component/>
                        </LayoutWarpper> : <route.component/>}
                    </ErrorBoundary>}
            />
        );
    });

    // if(!isAuth) {
    //     displayComponent = routes.filter((route) => route.auth === false).map((r, index) => {
    //         return (
    //             <Route
    //                 key={ index }
    //                 path={ r.path }
    //                 element={ <ErrorBoundary name={ r.path }>
    //                     <Layout>
    //                     <r.component />
    //                     </Layout>
    //                 </ErrorBoundary> }
    //             />
    //         );
    //     })
    // }

    return (
        <BrowserRouter>
            <Routes>
                {
                    displayComponent.map((route, index) => {
                        return route;
                    })
                }
                <Route path='*' element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
};

const LayoutWarpper = ({ children }: { children: React.ReactNode }) => {

    return <Layout>
        {children}
    </Layout>;
};

export default AppRoutes;
